import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortNameToLongName'
})
export class ShortNameToLongNamePipe implements PipeTransform {
  transform(shortName: string): string {
    switch (shortName) {
      case 'barrier':
        return 'Barrier';
      case 'barrierType':
        return 'Barrier Type';
      case 'calculationAgent':
        return 'Calculation Agent';
      case 'counterPartyA':
        return 'Counter Party A';
      case 'counterPartyB':
        return 'Counter Party B';
      case 'cross':
        return 'Cross';
      case 'currency':
        return 'Currency';
      case 'cutOff':
        return 'Cut Off';
      case 'executionVenue':
        return 'Execution Venue';
      case 'expiryDate':
        return 'Expiry Date';
      case 'fixingConvention':
        return 'Fixing Convention';
      case 'linkId':
        return 'Link Id';
      case 'midPv':
        return 'Mid Pv';
      case 'midPvCurrency':
        return 'Mid Pv Currency';
      case 'notional':
        return 'Notional';
      case 'parentProductCode':
        return 'Parent Product Code';
      case 'position':
        return 'Position';
      case 'premium':
        return 'Premium';
      case 'premiumCurrency':
        return 'Premium Currency';
      case 'premiumPayer':
        return 'Premium Payer';
      case 'premiumPaymentDate':
        return 'Premium Payment Date';
      case 'premiumSettlementCurrency':
        return 'Premium Settlement Currency';
      case 'productType':
        return 'Product Type';
      case 'settlementConvention':
        return 'Settlement Convention';
      case 'settlementDate':
        return 'Settlement Date';
      case 'settlementType':
        return 'Settlement Type';
      case 'theta':
        return 'Theta';
      case 'timestamp':
        return 'Timestamp';
      case 'tradeDate':
        return 'Trade Date';
      case 'tradeId':
        return 'Trade Id';
      case 'tradeStatus':
        return 'trade Status';
      case 'traderName':
        return 'Trader Name';
      case 'valuationAdjustment':
        return 'Valuation Adjustment';
      case 'valuationAdjustmentAmortizationEndDate':
        return 'Valuation Adjustment Amortization End Date';
      case 'valuationAdjustmentAmortizationStartDate':
        return 'Valuation Adjustment Amortization Start Date';
      case 'valuationAdjustmentCurrency':
        return 'Valuation Adjustment Currency';
      case 'valuationAdjustmentInFavourOf':
        return 'Valuation Adjustment In Favour Of';
      default:
        return shortName;
    }
  }
}
